const config = {
    BACKEND: "https://api.dme-tech.com/api/v2/",
    PAYPALCLIENTID: "AVmvc0HSvvZpUHp2zXn6Cu2WrR55lx2JqNAu_oilG_swqCPAEBs4gXaRgSj61fj4ZQq69RyuzMzzM77L",
    debugMode: false,
  };
  
  export default config;